<template>
  <section class="dflexc-jcs merchant-personal-data">
    <div class="mpd-header">Merchant Data</div>
    <div class="dflexr-jcs main-row" >
      <div class="dflexc-jcs money-bag">
        <div class="money-bag-header">
          Purse
        </div>
        <div class="dflexc-jcs money-bag-box">
          <div class="money-bag-row copper"
            v-if="merchant.money_bag.copper > 0">
            {{ merchant.money_bag.copper }}c
          </div>
          <div class="money-bag-row silver">
            {{ merchant.money_bag.silver }}s
          </div>
          <div class="money-bag-row gold"
               v-if="merchant.money_bag.gold > 0">
            {{ merchant.money_bag.gold }}g
          </div>
          <div class="money-bag-row mythril"
               v-if="merchant.money_bag.mythril > 0">
            {{ merchant.money_bag.mythril }}m
          </div>
        </div>
      </div>
      <div class="dflexc-jcc personal-items-col">
        <div class="personal-item-view" v-if="showPersonalItems"
             @click="showPersonalItems = !showPersonalItems">
          <div class="personal-item" v-for="item in merchant._items">
            {{ item.strval }}
          </div>
        </div>
        <div class="personal-item-view" v-else
          @click="showPersonalItems = !showPersonalItems">
          Show Items
        </div>

      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@import "@/assets/styles/colors.scss";

  .merchant-personal-data {
    border: 1px solid black;
    width: 100%;
    //height: 60px;
    border-top-left-radius: .5rem;
    border-top-right-radius: .5rem;
    margin-top: 1rem;
    margin-right: 1rem;

    background-color: $bg-drk20;

    .main-row {
      flex: 1;
      gap: .5rem;
    }

    .personal-items-col {
      flex: 1;
      background-color: rgba(255, 255, 255, 0.1);

      .personal-item-view {

      }

    }

    .mpd-header {
      width: 100%;
      background-color: black;
    }

    .money-bag {
      background-color: rgba(255, 255, 255, 0.1);

      .money-bag-header {
        margin: 2px 0 2px 0;
        font-size: .8rem;
        width: 100%;
        background-color: rgba(255, 255, 255, 0.1);
        color: $fg-base;
        border-bottom: 1px solid $bg-base;
      }

      .money-bag-box {
        padding-inline: .4rem;
        text-align: right;
        .copper {
          color: #ac6616;
        }

        .silver {
          color: #bfbfbf;
        }

        .gold {
          color: gold;
        }

        .mythril {
          color: #84e1e4;
        }
      }

    }
  }
</style>

<script setup>
import {ref, onUpdated, onMounted} from "vue";
const props = defineProps(['merchant'])

const showPersonalItems = ref(false)
let xMerchant = ref(props.merchant)

onUpdated( () => {
  if(xMerchant.value !== props.merchant) {
    showPersonalItems.value = false
    xMerchant.value = props.merchant
  }
})

</script>
